var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarsIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.7;}.cls-1,.cls-2,.cls-3{mix-blend-mode:multiply;}.cls-4{opacity:.1;}.cls-4,.cls-5{fill:#d7f1ff;mix-blend-mode:screen;}.cls-6{isolation:isolate;}.cls-2{opacity:.3;}.cls-2,.cls-7,.cls-3{fill:#5c7784;}.cls-5{opacity:.2;}.cls-8{fill:#ee332d;}.cls-3{opacity:.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_-_copie"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288,144c0,23.07-5.43,44.88-15.08,64.21-10.17,20.39-25.03,38.02-43.18,51.49-1.2,.89-2.41,1.77-3.64,2.61-23.29,16.2-51.59,25.69-82.1,25.69C64.47,288,0,223.53,0,144,0,98.4,21.2,57.74,54.28,31.35,76.85,13.35,104.96,1.99,135.64,.24c2.77-.16,5.55-.24,8.36-.24,73.25,0,133.73,54.69,142.81,125.47,.79,6.07,1.19,12.25,1.19,18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M286.81,125.47c-17.87,18.23-42.77,29.53-70.31,29.53-54.4,0-98.5-44.1-98.5-98.5,0-20.92,6.52-40.31,17.64-56.26,2.77-.16,5.55-.24,8.36-.24,73.25,0,133.73,54.69,142.81,125.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 192,
    cy: 76,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.92,208.21c-10.17,20.39-25.03,38.02-43.18,51.49-1.2,.89-2.41,1.77-3.64,2.61-23.29,16.2-51.59,25.69-82.1,25.69C64.47,288,0,223.53,0,144,0,98.4,21.2,57.74,54.28,31.35c-3.15,6.57-5.81,13.41-7.95,20.48-.05,.16-.1,.33-.15,.5-.52,1.72-1,3.46-1.45,5.2-2.99,11.58-4.58,23.72-4.58,36.23,0,16.94,2.91,33.2,8.27,48.3,.64,1.8,1.31,3.59,2.03,5.36,2.16,5.42,4.64,10.67,7.42,15.74,.29,.53,.59,1.05,.89,1.58,1.23,2.19,2.52,4.34,3.86,6.45,.98,1.54,1.98,3.05,3.02,4.55,19.22,27.85,47.96,48.63,81.52,57.62,2.53,.68,5.08,1.29,7.65,1.82,4.91,1.04,9.91,1.82,14.98,2.34,4.9,.5,9.86,.76,14.89,.76s9.97-.26,14.85-.76c.24-.02,.48-.05,.72-.07,15.07-1.61,29.46-5.55,42.8-11.45,10.71-4.73,20.73-10.72,29.87-17.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M198.58,239.84c1.06-2.07,1.65-4.39,1.65-6.84,0-8.84-7.71-16-17.23-16-5.52,0-10.44,2.41-13.58,6.16,2.76-5.42,8.7-9.16,15.58-9.16,9.52,0,17.23,7.16,17.23,16,0,3.71-1.36,7.13-3.65,9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200.23,233c0,2.45-.59,4.77-1.65,6.84-3.14,3.75-8.06,6.16-13.58,6.16-9.52,0-17.23-7.16-17.23-16,0-2.45,.59-4.77,1.65-6.84,3.14-3.75,8.06-6.16,13.58-6.16,9.52,0,17.23,7.16,17.23,16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M160.09,232.14c.55-1.08,.86-2.29,.86-3.57,0-4.62-4.03-8.36-9-8.36-2.88,0-5.45,1.26-7.09,3.22,1.44-2.83,4.54-4.78,8.14-4.78,4.97,0,9,3.74,9,8.36,0,1.94-.71,3.72-1.91,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.96,228.57c0,1.28-.31,2.49-.86,3.57-1.64,1.96-4.21,3.22-7.09,3.22-4.97,0-9-3.74-9-8.36,0-1.28,.31-2.49,.86-3.57,1.64-1.96,4.21-3.22,7.09-3.22,4.97,0,9,3.74,9,8.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M181.73,261.43c.37-.72,.57-1.53,.57-2.38,0-3.08-2.68-5.57-6-5.57-1.92,0-3.64,.84-4.73,2.15,.96-1.89,3.03-3.19,5.43-3.19,3.32,0,6,2.49,6,5.57,0,1.29-.47,2.48-1.27,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M182.3,259.04c0,.85-.21,1.66-.57,2.38-1.09,1.31-2.81,2.15-4.73,2.15-3.32,0-6-2.49-6-5.57,0-.85,.21-1.66,.57-2.38,1.09-1.31,2.81-2.15,4.73-2.15,3.32,0,6,2.49,6,5.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M168.15,269.28c.25-.48,.38-1.02,.38-1.59,0-2.05-1.79-3.71-4-3.71-1.28,0-2.42,.56-3.15,1.43,.64-1.26,2.02-2.13,3.62-2.13,2.21,0,4,1.66,4,3.71,0,.86-.32,1.66-.85,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.54,267.7c0,.57-.14,1.11-.38,1.59-.73,.87-1.87,1.43-3.15,1.43-2.21,0-4-1.66-4-3.71,0-.57,.14-1.11,.38-1.59,.73-.87,1.87-1.43,3.15-1.43,2.21,0,4,1.66,4,3.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M48.15,206.28c.25-.48,.38-1.02,.38-1.59,0-2.05-1.79-3.71-4-3.71-1.28,0-2.42,.56-3.15,1.43,.64-1.26,2.02-2.13,3.62-2.13,2.21,0,4,1.66,4,3.71,0,.86-.32,1.66-.85,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.54,204.7c0,.57-.14,1.11-.38,1.59-.73,.87-1.87,1.43-3.15,1.43-2.21,0-4-1.66-4-3.71,0-.57,.14-1.11,.38-1.59,.73-.87,1.87-1.43,3.15-1.43,2.21,0,4,1.66,4,3.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M51.36,217.71c.18-.36,.29-.76,.29-1.19,0-1.54-1.34-2.79-3-2.79-.96,0-1.82,.42-2.36,1.07,.48-.94,1.51-1.59,2.71-1.59,1.66,0,3,1.25,3,2.79,0,.65-.24,1.24-.64,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.65,216.52c0,.43-.1,.83-.29,1.19-.55,.65-1.4,1.07-2.36,1.07-1.66,0-3-1.25-3-2.79,0-.43,.1-.83,.29-1.19,.55-.65,1.4-1.07,2.36-1.07,1.66,0,3,1.25,3,2.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.58,209.14c.12-.24,.19-.51,.19-.79,0-1.03-.89-1.86-2-1.86-.64,0-1.21,.28-1.58,.72,.32-.63,1.01-1.06,1.81-1.06,1.11,0,2,.83,2,1.86,0,.43-.16,.83-.42,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.77,208.35c0,.28-.07,.55-.19,.79-.36,.44-.94,.72-1.58,.72-1.11,0-2-.83-2-1.86,0-.28,.07-.55,.19-.79,.36-.44,.94-.72,1.58-.72,1.11,0,2,.83,2,1.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.77,268.6c1.52-2.65,2.36-5.62,2.36-8.76,0-11.32-11.05-20.49-24.69-20.49-7.91,0-14.96,3.09-19.46,7.89,3.96-6.94,12.47-11.73,22.33-11.73,13.64,0,24.69,9.17,24.69,20.49,0,4.75-1.95,9.13-5.23,12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.13,259.84c0,3.14-.85,6.11-2.36,8.76-4.5,4.8-11.55,7.89-19.46,7.89-13.64,0-24.69-9.17-24.69-20.49,0-3.14,.85-6.11,2.36-8.76,4.5-4.8,11.55-7.89,19.46-7.89,13.64,0,24.69,9.17,24.69,20.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.25,169c1.09-2.24,1.69-4.76,1.69-7.41,0-9.58-7.92-17.34-17.69-17.34-5.67,0-10.72,2.61-13.94,6.68,2.83-5.87,8.93-9.93,16-9.93,9.78,0,17.69,7.76,17.69,17.34,0,4.02-1.4,7.73-3.75,10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.95,161.59c0,2.66-.61,5.17-1.69,7.41-3.22,4.06-8.28,6.68-13.94,6.68-9.78,0-17.69-7.76-17.69-17.34,0-2.66,.61-5.17,1.69-7.41,3.22-4.06,8.28-6.68,13.94-6.68,9.78,0,17.69,7.76,17.69,17.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.74,199.79c.66-1.36,1.02-2.88,1.02-4.48,0-5.79-4.78-10.48-10.69-10.48-3.43,0-6.48,1.58-8.43,4.03,1.71-3.55,5.4-6,9.67-6,5.91,0,10.69,4.69,10.69,10.48,0,2.43-.84,4.67-2.26,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.76,195.31c0,1.6-.37,3.12-1.02,4.48-1.95,2.46-5,4.03-8.43,4.03-5.91,0-10.69-4.69-10.69-10.48,0-1.6,.37-3.12,1.02-4.48,1.95-2.46,5-4.03,8.43-4.03,5.91,0,10.69,4.69,10.69,10.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.74,47.79c.66-1.36,1.02-2.88,1.02-4.48,0-5.79-4.78-10.48-10.69-10.48-3.43,0-6.48,1.58-8.43,4.03,1.71-3.55,5.4-6,9.67-6,5.91,0,10.69,4.69,10.69,10.48,0,2.43-.84,4.67-2.26,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.76,43.31c0,1.6-.37,3.12-1.02,4.48-1.95,2.46-5,4.03-8.43,4.03-5.91,0-10.69-4.69-10.69-10.48,0-1.6,.37-3.12,1.02-4.48,1.95-2.46,5-4.03,8.43-4.03,5.91,0,10.69,4.69,10.69,10.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.84,61.32c.63-1.05,.98-2.22,.98-3.46,0-4.47-4.56-8.1-10.19-8.1-3.27,0-6.18,1.22-8.03,3.12,1.63-2.74,5.15-4.64,9.22-4.64,5.63,0,10.19,3.62,10.19,8.1,0,1.88-.8,3.61-2.16,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.82,57.86c0,1.24-.35,2.41-.98,3.46-1.86,1.9-4.77,3.12-8.03,3.12-5.63,0-10.19-3.62-10.19-8.1,0-1.24,.35-2.41,.98-3.46,1.86-1.9,4.77-3.12,8.03-3.12,5.63,0,10.19,3.62,10.19,8.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.69,62.37c.38-.64,.59-1.35,.59-2.1,0-2.72-2.77-4.92-6.19-4.92-1.98,0-3.75,.74-4.88,1.89,.99-1.67,3.13-2.82,5.6-2.82,3.42,0,6.19,2.2,6.19,4.92,0,1.14-.49,2.19-1.31,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.28,60.26c0,.75-.21,1.47-.59,2.1-1.13,1.15-2.9,1.89-4.88,1.89-3.42,0-6.19-2.2-6.19-4.92,0-.75,.21-1.47,.59-2.1,1.13-1.15,2.9-1.89,4.88-1.89,3.42,0,6.19,2.2,6.19,4.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.32,66.9c.2-.33,.31-.7,.31-1.08,0-1.4-1.43-2.54-3.19-2.54-1.02,0-1.93,.38-2.52,.98,.51-.86,1.61-1.45,2.89-1.45,1.76,0,3.19,1.13,3.19,2.54,0,.59-.25,1.13-.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M69.63,65.82c0,.39-.11,.76-.31,1.08-.58,.59-1.49,.98-2.52,.98-1.76,0-3.19-1.13-3.19-2.54,0-.39,.11-.76,.31-1.08,.58-.59,1.49-.98,2.52-.98,1.76,0,3.19,1.13,3.19,2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.32,43.9c.2-.33,.31-.7,.31-1.08,0-1.4-1.43-2.54-3.19-2.54-1.02,0-1.93,.38-2.52,.98,.51-.86,1.61-1.45,2.89-1.45,1.76,0,3.19,1.13,3.19,2.54,0,.59-.25,1.13-.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M57.63,42.82c0,.39-.11,.76-.31,1.08-.58,.59-1.49,.98-2.52,.98-1.76,0-3.19-1.13-3.19-2.54,0-.39,.11-.76,.31-1.08,.58-.59,1.49-.98,2.52-.98,1.76,0,3.19,1.13,3.19,2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M41.32,62.9c.2-.33,.31-.7,.31-1.08,0-1.4-1.43-2.54-3.19-2.54-1.02,0-1.93,.38-2.52,.98,.51-.86,1.61-1.45,2.89-1.45,1.76,0,3.19,1.13,3.19,2.54,0,.59-.25,1.13-.68,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.63,61.82c0,.39-.11,.76-.31,1.08-.58,.59-1.49,.98-2.52,.98-1.76,0-3.19-1.13-3.19-2.54,0-.39,.11-.76,.31-1.08,.58-.59,1.49-.98,2.52-.98,1.76,0,3.19,1.13,3.19,2.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.16,174.91c.53-.75,.83-1.59,.83-2.48,0-3.21-3.89-5.8-8.69-5.8-2.78,0-5.27,.87-6.85,2.23,1.39-1.97,4.39-3.32,7.86-3.32,4.8,0,8.69,2.6,8.69,5.8,0,1.35-.69,2.59-1.84,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.99,172.43c0,.89-.3,1.73-.83,2.48-1.58,1.36-4.07,2.23-6.85,2.23-4.8,0-8.69-2.6-8.69-5.8,0-.89,.3-1.73,.83-2.48,1.58-1.36,4.07-2.23,6.85-2.23,4.8,0,8.69,2.6,8.69,5.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.1,262.31c1.23-.85,2.44-1.73,3.64-2.61-1.2,.89-2.41,1.77-3.64,2.61Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarsIcons);
export default __webpack_public_path__ + "static/media/marsIcons.d4c673d0b2378b54f353341f07a818d6.svg";
export { ForwardRef as ReactComponent };